<template>
  <div class="cooperation scroll-container">
    <div class="cooperation_hea">
      <myHeaderW @roll="rollFn"></myHeaderW>
    </div>

    <div class="cooperation_ban">
      <img :src="$httpImg + '/img/bag/cooperation.png'" />
      <div class="cooperation_ban_center">
        <h4>入驻合作</h4>
        <p>cooperation</p>
      </div>
    </div>

    <div class="cooperation_one" id="cooperation0">
      <h3>商家入驻流程</h3>
      <div class="cooperation_one_ul">
        <div class="cooperation_one_li">
          <div>
            <div class="cooperation_one_li_top">
              <img :src="$httpImg + '/img/icon/icon_cooperation1.png'" />
            </div>
            <div class="cooperation_one_li_bot">
              <h6>第1步：准备资料</h6>
              <p>
                下载超拼网APP，选择开店，准备 好所需的资料。填入后提交申请。
              </p>
            </div>
          </div>
        </div>
        <img :src="$httpImg + '/img/icon/icon_left.png'" class="icon_left" />
        <div class="cooperation_one_li">
          <div>
            <div class="cooperation_one_li_top">
              <img :src="$httpImg + '/img/icon/icon_cooperation2.png'" />
            </div>
            <div class="cooperation_one_li_bot">
              <h6>第2步：平台审核</h6>
              <p>平台进行评估、资质审核 （约1-5个工作日）</p>
            </div>
          </div>
        </div>
        <img :src="$httpImg + '/img/icon/icon_left.png'" class="icon_left" />
        <div class="cooperation_one_li">
          <div>
            <div class="cooperation_one_li_top">
              <img :src="$httpImg + '/img/icon/icon_cooperation3.png'" />
            </div>
            <div class="cooperation_one_li_bot">
              <h6>第3步：缴纳保证金</h6>
              <p>平台审核通过后，通过对公账户 缴纳保证金（约1-3个工作日）</p>
            </div>
          </div>
        </div>
        <img :src="$httpImg + '/img/icon/icon_left.png'" class="icon_left" />
        <div class="cooperation_one_li">
          <div>
            <div class="cooperation_one_li_top">
              <img :src="$httpImg + '/img/icon/icon_cooperation4.png'" />
            </div>
            <div class="cooperation_one_li_bot">
              <h6>第4步：入驻开店成功</h6>
              <p>开店成功，开始运营你的店铺吧</p>
            </div>
          </div>
        </div>
      </div>
      <button class="gree_button" @click="goto('/download')">
        下载APP开店
      </button>
    </div>
    <div class="cooperation_two" id="cooperation1">
      <h3 ref="cooperation1">资质要求</h3>
      <div class="cooperation_two_center">
        <el-tabs
          v-model="activeName"
          type="card"
          class="demo-tabs"
          @tab-click="handleClick"
        >
          <el-tab-pane label="个人店" name="user">
            <div v-html="data.aptitudeFirm"></div>
            <!-- <el-row :gutter="20" class="th">
                            <el-col :span="6" class="tb1">
                                序号
                            </el-col>
                            <el-col :span="6" class="tb1">
                                主要资质
                            </el-col>
                            <el-col :span="6" class="tb1">
                                说明
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" class="tr">
                            <el-col :span="6" class="tb">
                                1
                            </el-col>
                            <el-col :span="6" class="tb">
                                身份证人像面照片<br> 身份证国徽面照片
                            </el-col>
                            <el-col :span="6" class="tb">
                                1、必须是中国大陆身份证 <br>2、距离有效期截至时间应大于1个月 <br>3、证件清晰，图片上传不要倒置
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" class="tr">
                            <el-col :span="6" class="tb">
                                2
                            </el-col>
                            <el-col :span="6" class="tb">
                                个体工商户营业执照
                            </el-col>
                            <el-col :span="6" class="tb">
                                1、个体户执照需要上传原件
                                2、属于入驻人的个体户执照 
                                3、公司类型为个体户性质 
                                4、距离有效期截至时间应大于1个月 
                                5、证件清晰
                            </el-col>
                        </el-row> -->
          </el-tab-pane>
          <el-tab-pane label="企业店">
            <div v-html="data.aptitudeUser"></div>
          </el-tab-pane>
          <el-tab-pane label="医药店">
            <div v-html="data.medicine"></div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="cooperation_tree" id="cooperation2">
      <h3>代运营服务商入驻</h3>
      <div class="cooperation_tree_ul">
        <div class="cooperation_tree_li">
          <div class="flex_column">
            <div class="cooperation_tree_li_top">
              <img :src="$httpImg + '/img/icon/icon_cooperation5.png'" />
            </div>
            <div class="cooperation_tree_li_bot">
              <h6>电话联系</h6>
              <p>招商负责人</p>
            </div>
          </div>
        </div>
        <img :src="$httpImg + '/img/icon/icon_left1.png'" class="icon_left" />
        <div class="cooperation_tree_li">
          <div class="flex_column">
            <div class="cooperation_tree_li_top">
              <img :src="$httpImg + '/img/icon/icon_cooperation6.png'" />
            </div>
            <div class="cooperation_tree_li_bot">
              <h6>沟通具体品类及需求</h6>
              <p>达成初步意向</p>
            </div>
          </div>
        </div>
        <img :src="$httpImg + '/img/icon/icon_left1.png'" class="icon_left" />
        <div class="cooperation_tree_li">
          <div class="flex_column">
            <div class="cooperation_tree_li_top">
              <img :src="$httpImg + '/img/icon/icon_cooperation7.png'" />
            </div>
            <div class="cooperation_tree_li_bot">
              <h6>沟通确认合同条款</h6>
              <p>完成合同签署</p>
            </div>
          </div>
        </div>
        <img :src="$httpImg + '/img/icon/icon_left1.png'" class="icon_left" />
        <div class="cooperation_tree_li">
          <div class="flex_column">
            <div class="cooperation_tree_li_top">
              <img :src="$httpImg + '/img/icon/icon_cooperation8.png'" />
            </div>
            <div class="cooperation_tree_li_bot">
              <h6>平台为服务商</h6>
              <p>开通平台店铺</p>
            </div>
          </div>
        </div>
        <img :src="$httpImg + '/img/icon/icon_left1.png'" class="icon_left" />
        <div class="cooperation_tree_li">
          <div class="flex_column">
            <div class="cooperation_tree_li_top">
              <img :src="$httpImg + '/img/icon/icon_cooperation9.png'" />
            </div>
            <div class="cooperation_tree_li_bot">
              <h6>运营人员对接</h6>
              <p>开始运营工作</p>
            </div>
          </div>
        </div>
      </div>
      <div class="ger_bot"></div>
    </div>
    <myFooter></myFooter>
  </div>
</template>

<script>
import { reactive, ref, toRefs } from "@vue/reactivity";
import myHeaderW from "@/components/myHeaderW.vue";
import myFooter from "@/components/myFooter.vue";
import { getconfig } from "@/comm/api";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

export default {
  components: {
    myHeaderW,
    myFooter,
  },
  setup() {
    const activeName = ref("user");
    let data = reactive({
      phone: "暂无",
      aptitudeUser: "",
      aptitudeFirm: "",
      medicine: "",
    });
    const handleClick = (tab, event) => {
      console.log(tab, event);
    };
    const getconfigFn = async (configName) => {
      try {
        const res = await getconfig({ configName: configName });
        console.log(1, res);
        if (res.code == 1) {
          data[configName] = res.data;
        }
      } catch (err) {
        console.error("失败", err);
      }
    };
    const router = useRouter();
    const goto = (path) => {
      router.push(path);
    };
    const cooperation1 = ref(null);

    const rollFn = (id) => {
      console.log(cooperation1.value, "id");
      const rect = cooperation1.value.getBoundingClientRect();
      console.log("元素的位置是:", {
        top: rect.top + window.scrollY, // 元素顶部相对于文档顶部的距离
        // 元素的高度
      });
      window.scrollTo({
        top: rect.top + window.scrollY,
        behavior: "smooth", // 添加滚动动画效果
      });
    };
    onMounted(() => {
      getconfigFn("phone");
      getconfigFn("aptitudeUser");
      getconfigFn("aptitudeFirm");
      getconfigFn("medicine");
    });
    return {
      data,
      goto,
      activeName,
      getconfigFn,
      handleClick,
      rollFn,
      cooperation1,
    };
  },
};
</script>

<style lang="scss" scoped>
.cooperation {
  background: #fff;
}

.el-radio input[aria-hidden="true"] {
  display: none !important;
}

.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none !important;
}

.cooperation_hea {
  width: 100%;
  background: #fff;
}

.cooperation_ban {
  position: relative;

  img {
    position: relative;
    width: 100%;
  }

  .cooperation_ban_center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    h4 {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 45px;
      color: #ffffff;
      text-align: center;
    }

    p {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 20px;
      text-align: center;
      color: #ffffff;
    }
  }
}

.cooperation_one {
  background: #fff;
  padding: 40px;
  height: 500px;
  position: relative;

  .gree_button {
    width: 282px;
    height: 48px;
    background: #30c9c4;
    border-radius: 24px;
    border: none;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
  }

  .cooperation_one_ul {
    display: flex;
    justify-content: space-evenly;
    width: 1200px;
    margin: 60px auto;

    .icon_left {
      // width: 50px;
      height: 20px;
      margin-top: 80px;
    }

    .cooperation_one_li {
      display: flex;
      align-items: center;

      .cooperation_one_li_top {
        background: #f5f4f4;
        border-radius: 10px;
        position: relative;
        height: 180px;
        width: 150px;

        img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 30px;
          height: 30px;
        }
      }

      .cooperation_one_li_bot {
        width: 180px;
        margin-top: 20px;

        h6 {
          font-family: Microsoft YaHei;
          font-weight: bold;
          font-size: 14px;
          color: #333333;
          text-align: center;
        }

        p {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          text-align: center;
        }
      }
    }
  }

  h3 {
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 26px;
    color: #333333;
    text-align: center;
  }
}

.cooperation_two {
  background: #fafafa;
  padding: 40px;

  h3 {
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 26px;
    color: #333333;
    text-align: center;
  }

  .cooperation_two_center {
    width: 1200px;
    margin: 40px auto;

    .th {
      background: #eeeeee !important;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }

    .tb1 {
    }

    .tr {
      border-bottom: 1px solid #dcdcdc;
      text-align: center;
    }

    .tb {
      border-left: 1px solid #dcdcdc;
      text-align: center;
      padding: 20px;
      display: flex;

      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }
}

.cooperation_tree {
  background: #fff;
  padding: 40px;
  height: 450px;
  position: relative;

  h3 {
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 26px;
    color: #333333;
    text-align: center;
  }

  .ger_bot {
    width: 300px;
    height: 60px;
    border-radius: 10px;
    border: 1px solid #7ecef4;
    position: absolute;
    left: 50%;
    bottom: 40px;
    background: url("../../assets/img/icon/icon_cooperation_phone.png")
      no-repeat 50%;
    background-size: 90%;
    transform: translateX(-50%);
  }

  .cooperation_tree_ul {
    display: flex;
    justify-content: space-evenly;
    width: 1200px;
    margin: 60px auto;

    .icon_left {
      width: 50px;
      height: 45px;
      margin-top: 40px;
    }

    .flex_column {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .cooperation_tree_li {
      display: flex;
      align-items: center;

      .cooperation_tree_li_top {
        border-radius: 10px;
        position: relative;
        width: 130px;
        height: 130px;
        border-radius: 50%;
        border: 1px solid #7ecef4;

        img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 30px;
          height: 30px;
        }
      }

      .cooperation_tree_li_bot {
        width: 180px;
        margin-top: 20px;

        h6 {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #595959;
          text-align: center;
        }

        p {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #595959;
          text-align: center;
        }
      }
    }
  }
}
:deep(.el-tabs__item:hover) {
  color: #303133 !important;
}
:deep(.el-tabs__item.is-active) {
  color: #fff !important;
}
:deep(.el-tabs--card > .el-tabs__header .el-tabs__item.is-active) {
  background: #30c9c4 !important;
}
:deep(.el-tabs--card > .el-tabs__header .el-tabs__nav) {
  border-color: #ffff;
}
:deep(.el-tabs--card > .el-tabs__header .el-tabs__item) {
  border-color: #ffff;
  background: #e5e5e5 !important;
  margin: 2px;
}
</style>